/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

// Material UI
import { Snackbar as SnackbarBase, SnackbarProps } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

// Clsx
import clsx from 'clsx';

// Actions
import * as SnackbarActions from 'store/ducks/snackbars/actions';

import { ApplicationState } from 'store';

// Custom Alert Component
function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

type Props = SnackbarProps;

const useStyles = makeStyles(() =>
  createStyles({
    warning: {
      backgroundColor: '#ff9800 !important',
    },
  }),
);

const Snackbar: React.FunctionComponent<Props> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { pathname } = window.location;

  const { open, type, message } = useSelector(
    (state: ApplicationState) => state.snackbars.snackbar,
  );

  return (
    <SnackbarBase
      open={open || false}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={() => dispatch(SnackbarActions.setClose())}>
      <Alert
        severity={type || 'info'}
        className={clsx({
          [classes.warning]: pathname === '/login',
        })}
        onClose={() => dispatch(SnackbarActions.setClose())}>
        {message}
      </Alert>
    </SnackbarBase>
  );
};

export default Snackbar;
